import { render, staticRenderFns } from "./view_must_login.vue?vue&type=template&id=72102db4&"
import script from "./view_must_login.vue?vue&type=script&lang=js&"
export * from "./view_must_login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports